import { useMemo } from 'react'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

const watchEntityKeys = ['orderItemTaskAttachments']

type OrderItemTaskAttachmentFilters = {
  order_item_task_id?: number,
}

type UseOrderItemTaskAttachmentsOptions = {
  filters?: OrderItemTaskAttachmentFilters,
  performHttpRequests?: boolean,
}

function useOrderItemTaskAttachments(options: UseOrderItemTaskAttachmentsOptions) {
  const { filters = {} } = options
  const {
    order_item_task_id: filterOrderItemTaskId,
  } = filters

  const {
    updatedEntities: { orderItemTaskAttachments: orderItemTaskAttachmentsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { orderItemTaskAttachments } = useSelector(reduxState => reduxState.entities)

  const filteredOrderItemTaskAttachments = useMemo(() => {
    const filtered = Object.values(orderItemTaskAttachments).filter((orderItemTaskAttachment) => {
      const { order_item_task_id } = orderItemTaskAttachment

      const matchOrderItemTaskId = matchFilterNumber(order_item_task_id, filterOrderItemTaskId)

      return matchOrderItemTaskId
    })

    return sortArrayBy(filtered, 'asc', 'id')
  }, [orderItemTaskAttachmentsUpdatedAt, JSON.stringify(filters)])

  const filteredOrderItemTaskAttachmentsCount = filteredOrderItemTaskAttachments.length
  const hasFilteredOrderItemTaskAttachments = !!filteredOrderItemTaskAttachmentsCount

  return {
    filteredOrderItemTaskAttachments,
    filteredOrderItemTaskAttachmentsCount,
    hasFilteredOrderItemTaskAttachments,
  }
}

export type UseOrderItemTaskAttachmentsPayload = ReturnType<typeof useOrderItemTaskAttachments>

export default useOrderItemTaskAttachments
